export enum ProductItemStatus {
  CREATED = "CREATED",
  IN_STOCK = "IN_STOCK",
  RESERVED = "RESERVED",
  SOLD = "SOLD",
  DAMAGED = "DAMAGED",
  EXPIRED = "EXPIRED",
  LOST = "LOST",
  CONSUMED = "CONSUMED"
}
